
import { defineComponent } from "vue";

export default defineComponent({
  setup(props, context) {
    context.emit("header", true);
    context.emit("start");
    context.emit("contentShow", true);
  },
});
